import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { useSelector } from "react-redux";
import { showToast } from "./ToastNotification";
import "./Cart.css";

const Cart = () => {
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = useSelector((state) => state.auth.user);
    const userId = user?.id;

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            return;
        }

        const fetchCartItems = async () => {
            try {
                const cartResponse = await axiosInstance.get(`${API_ENDPOINTS.GET_CART}/${userId}`);
                const cartData = cartResponse?.data?.data?.cartItems || [];

                const productsWithDetails = await Promise.all(
                    cartData.map(async (item) => {
                        try {
                            const productResponse = await axiosInstance.get(`${API_ENDPOINTS.PRODUCT_DETAILS}/${item.productId}`);
                            return { ...item, productDetails: productResponse?.data?.data };
                        } catch (error) {
                            console.error(`Error fetching product details for ${item.productId}`, error);
                            return item; // Return item without additional product details
                        }
                    })
                );

                setCartItems(productsWithDetails);
            } catch (error) {
                console.error("Error fetching cart items:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCartItems();
    }, [userId]);

    const handleRemoveFromCart = async (productId) => {
        try {
            await axiosInstance.delete(`${API_ENDPOINTS.REMOVE_FROM_CART}/${productId}?userId=${userId}`);
            setCartItems((prevItems) => prevItems.filter((item) => item.productId !== productId));
            showToast("Item removed from cart", "success");
        } catch (error) {
            console.error("Error removing item from cart:", error);
        }
    };

    const totalPrice = cartItems.reduce((total, item) => total + item.productPrice * item.quantity, 0);

    if (loading) return <div className="container mt-5">Loading...</div>;
    if (!user) return <div className="container mt-5">Please login to check your cart.</div>;

    return (
        <div className="cart-container">
            <h2>Shopping Cart</h2>
            {cartItems.length === 0 ? (
                <p>Your cart is empty.</p>
            ) : (
                <>
                    <ul className="list-group mb-3">
                        {cartItems.map((item) => (
                            <li key={item.productId} className="cart-item">
                                <div className="cart-item-image">
                                    <img src={item.imageUrls} alt={item.productName} className="img-fluid" />
                                </div>
                                <div className="cart-item-info">
                                    <h5>{item.productName}</h5>
                                    <p>₹{item.productPrice} x {item.quantity}</p>
                                </div>
                                <div className="cart-item-actions">
                                    <div className="total-price">
                                        <span>₹{(item.productPrice * item.quantity).toFixed(2)}</span>
                                    </div>
                                    <div className="action-buttons">
                                       
                                        <Link to={`/checkout/${item.productId}`} className="btn btn-primary btn-sm">
                                            Proceed to Checkout
                                        </Link>
                                        <button onClick={() => handleRemoveFromCart(item.productId)} className="btn btn-danger btn-sm">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <h4 className="cart-total">Total: ₹{totalPrice.toFixed(2)}</h4>
                    <Link to="/checkout" className="btn btn-primary checkout-btn">
                        Proceed to Checkout (All Items)
                    </Link>
                </>
            )}
        </div>
    );
};

export default Cart;
